import { FunctionComponent, ReactNode } from 'react'
import classnames from 'classnames'

/**
 * Card with an optional header (title, description and actions).
 * Children are rendered as-is, so tables can sit flush with the card edges.
 */
const CardSection: FunctionComponent<{
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
  children: ReactNode
}> = ({ title, description, actions, className, children }) => (
  <section className={classnames('card', className)}>
    {(title || actions) && (
      <div className="card-head">
        <div>
          {title && <h2 className="card-title">{title}</h2>}
          {description && <p className="card-desc">{description}</p>}
        </div>
        {actions}
      </div>
    )}
    {children}
  </section>
)

export default CardSection
